import { bulkUploadImagesToR2, uploadImageToR2 } from './r2BulkUpload';

/**
 * Legacy upload function redirected to Cloudflare R2 backend pipeline.
 */
export async function bulkUploadImagesToCloudinary(images, folder = 'activity') {
    return bulkUploadImagesToR2(images, folder);
}

export { uploadImageToR2, bulkUploadImagesToR2 };
export default bulkUploadImagesToR2;